import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const ContactCaptureEmptyState = () => {
  const navigate = useNavigate();

  return (
    <Stack alignItems="center" justifyContent="center" spacing={1.5} sx={{ height: '100%', px: 2, textAlign: 'center' }}>
      <Typography variant="h6">Create contact capture</Typography>
      <Typography variant="body2" color="text.secondary" maxWidth={520}>
        Collect contacts with a website popup or an embedded form.
      </Typography>
      <Button variant="contained" size="small" onClick={() => navigate('/contact-capture/new')}>
        Create contact capture
      </Button>
    </Stack>
  );
};

